import type { Holding } from '../holding/types';

// Mirrors Angular's `userHoldingRelationByName` (corp-app.component.ts getUserRelation): the
// backend never sends a resolved "your relation to this holding" field — it has to be computed
// by finding the current user inside `holding.users_relations` and mapping the Portuguese label.
const RELATION_TYPE_BY_LABEL: Record<string, string> = {
  DONO: 'OWNER',
  PARCEIRO: 'PARTNER',
  FUNCIONÁRIO: 'EMPLOYEE',
  CONSULTA: 'CONSULTING',
};

// `Holding` has no `relation_type` field (see domain/holding/types.ts) — nothing in this app
// ever sets one. Callers that read `(holding as Record<string, unknown>).relation_type` are
// reading a value that's always `undefined` in production, which silently fails open on every
// owner/partner-only gate. Always compute it from `users_relations` instead, like Angular does.
export function getCurrentUserRelationType(
  holding: Holding | null | undefined,
  userId: string | undefined,
): string | undefined {
  if (!holding || !userId) return undefined;
  const relation = holding.users_relations?.find((r) => r.user?.id === userId);
  return RELATION_TYPE_BY_LABEL[relation?.relation_type ?? ''];
}

// Fails closed: an unresolved relation (missing users_relations, user not found, unknown label)
// is treated as NOT owner/partner — matching Angular, where `userHoldingRelationByName[undefined]`
// is `undefined` and `.includes(undefined)` is `false`.
export function isOwnerOrPartnerRelation(relationType: string | undefined): boolean {
  return relationType === 'OWNER' || relationType === 'PARTNER';
}
